import axios from 'axios';

const BASE_URL = process.env.VUE_APP_APIURL;

const search = (model, cancelToken) => axios.post(`${BASE_URL}/api/Reports/Search`, model, {
    cancelToken,
});
const adminSearch = (model, cancelToken) => axios.post(`${BASE_URL}/api/Reports/Admin/Search`, model, {
    cancelToken,
});
const adminSearchTransfers = (model, cancelToken) => axios.post(`${BASE_URL}/api/Reports/Admin/Search/Transfers`, model, {
    cancelToken,
});
const getPayments = (model, cancelToken) => axios.get(`${BASE_URL}/api/Reports/Payment/Pay`, {
    cancelToken,
});
const exportXsl = (model) => axios.post(`${BASE_URL}/api/Reports/Search/xlsx`, model, {
    responseType: 'blob',
});
const exportXslAdmin = (model) => axios.post(`${BASE_URL}/api/Reports/Admin/Search/Xlsx`, model, {
    responseType: 'blob',
});
const exportPaidReportsXsl = (model) => axios.post(`${BASE_URL}/api/Reports/Search/xlsx?exportType=1`, model, {
    responseType: 'blob',
});
const exportReportsXslBy = (model, type) => axios.post(`${BASE_URL}/api/Reports/Search/xlsx?exportType=${model.IsPaid ? 1 : 0}&groupingType=${type}`, model, {
    responseType: 'blob',
});
const exportUnmanagedReportsXsl = (model) => axios.post(`${BASE_URL}/api/Reports/Unmanaged/Xlsx`, model, {
    responseType: 'blob',
});
const removeFromProfile = (data) => axios.put(`${BASE_URL}/api/Reports/RemoveFromProfile`, data);

const getReportQrDetails = (url) => axios.get(`${BASE_URL}/api/Reports/ParseUrl?url=${url}`);
const getReport = (reportId) => axios.get(`${BASE_URL}/api/Reports/${reportId}`);
const getReportAdmin = (reportId) => axios.get(`${BASE_URL}/api/Reports/Admin/${reportId}`);
const getRePortCalls = (reportId) => axios.get(`${BASE_URL}/api/Reports/Admin/${reportId}/RePortCalls`);
const getReportContract = (reportId) => axios.get(`${BASE_URL}/api/Reports/${reportId}/Contracts`);
const getDriverContract = (id) => axios.get(`${BASE_URL}/api/Reports/${id}/DriverContract`);
const getVehicleContract = (id) => axios.get(`${BASE_URL}/api/Reports/${id}/VehicleContract`);
const getVirtualContracts = (id) => axios.get(`${BASE_URL}/api/Reports/${id}/VirtualContracts`);
const getPrivateVehicleContracts = (id) => axios.get(`${BASE_URL}/api/Reports/${id}/PrivateVehicleContracts`);
const getReportImages = (reportId) => axios.get(`${BASE_URL}/api/Reports/${reportId}/Images?isApp=false`);
const getReportImagesAdmin = (reportId) => axios.get(`${BASE_URL}/api/Reports/Admin/${reportId}/Images?isApp=false`);
const getTransferAdminById = (reportId, fromProfileId) => axios.get(`${BASE_URL}/api/Reports/Admin/${reportId}/From/${fromProfileId}`);
const update = (reportId, data) => axios.put(`${BASE_URL}/api/Reports/${reportId}`, data);
const updateAdmin = (reportId, data) => axios.put(`${BASE_URL}/api/Reports/Admin/${reportId}`, data);
const setPayment = (reportId, data) => axios.put(`${BASE_URL}/api/Reports/${reportId}/Payment`, data);
const setPayments = (data) => axios.put(`${BASE_URL}/api/Reports/Payment`, data);
const approvePayment = (data) => axios.put(`${BASE_URL}/api/Reports/ApprovePayment`, data);
const disapprovePayment = (data) => axios.put(`${BASE_URL}/api/Reports/DisapprovePayment`, data);
const setAsPaid = (data) => axios.put(`${BASE_URL}/api/Reports/Payment`, data);
const completeTransfers = (reportIds) => axios.put(`${BASE_URL}/api/Reports/CompleteTransfers`, reportIds);
const setStatus = (reportId, data) => axios.put(`${BASE_URL}/api/Reports/${reportId}/StatusEvents`, data);
const setStatuses = (data) => axios.put(`${BASE_URL}/api/Reports/Status`, data);
const setDeliveryMethod = (reportId, data) => axios.put(`${BASE_URL}/api/Reports/${reportId}/DeliveryEvent`, data);
const setAsUnpaid = (id) => axios.put(`${BASE_URL}/api/Reports/Admin/${id}/Payment/Unpaid`);
const importReports = (model) => axios.post(`${BASE_URL}/api/Reports/Batch`, model);
const importSingleReport = (model) => axios.post(`${BASE_URL}/api/Reports/Import/Single`, model);
const importSmartReports = (model) => axios.post(`${BASE_URL}/api/Reports/Batch/Smart`, model);
const importPolice = (model) => axios.post(`${BASE_URL}/api/Reports/FromPolice`, model);
const scanData = (fields, vehicles) => axios.put(`${BASE_URL}/api/Reports/Coordinates?emptyFieldsOnly=${fields}&managedVehiclesOnly=${vehicles}`);
const scanReports = (fields) => axios.put(`${BASE_URL}/api/Reports/FromMunicipality`, fields);
const updateReportAlert = (profileId, reportNumber, paidField) => axios.put(`${BASE_URL}/api/Reports/Alerts?profileId=${profileId}&reportNumber=${reportNumber}&unpaidOnly=${paidField}`);
const importReportsStatus = (uuid) => axios.get(`${BASE_URL}/api/Reports/Batch/${uuid}`);
const deleteStatus = (id, type) => axios.delete(`${BASE_URL}/api/Reports/${id}/Alert/${type}`);
const deleteReport = (reportId) => axios.delete(`${BASE_URL}/api/Reports/${reportId}`);
const createReport = (data, skipVerification) => axios.post(`${BASE_URL}/api/Reports?skipVerification=${skipVerification}`, data);
const fetchReportData = (municipalityId, plateNumber, reportNumber) => axios.get(`${BASE_URL}/api/Reports/FromMunicipality?municipalityId=${municipalityId}&plateNumber=${plateNumber}&reportNumber=${reportNumber}`);
const scanDetailsFromMunic = (data) => axios.put(`${BASE_URL}/api/Reports/FromMunicipality`, data);
const generateAlerts = (data) => axios.put(`${BASE_URL}/api/Reports/Alerts?reportNumber=${data.reportNumber}&unpaidOnly=true`);
const loadReportByNumber = (reportNumber, municipalityId) => axios.get(`${BASE_URL}/api/Reports/ByReportNumber/${reportNumber}/${municipalityId}`);
const getFields = (isSmartImport = false) => axios.get(`${BASE_URL}/api/Reports/Fields?isSmartImport=${isSmartImport}`);
const forMap = async (model, cancelToken) => {
    if (forMap.cache) return forMap.cache;
    const { data } = await axios.post(`${BASE_URL}/api/Reports/ForMap`, model, {
        cancelToken,
    });
    forMap.cache = data;

    return forMap.cache;
};
const getYearlyStatistics = (year) => axios.get(`${BASE_URL}/api/Statistics/Yearly/${year}`);

const produceJerusalemSingleReference = (data) => axios.put(`${BASE_URL}/api/Reports/Jerusalem/MergeReferences`, data);

const pullTransfersFromReport = (data) => axios.put(`${BASE_URL}/api/Reports/UpdateReportsFromRePort`, data);

const updateTransferDocuments = (reportId) => axios.put(`${BASE_URL}/api/Reports/UpdateTransferDocuments/${reportId}`);

const getBatchReports = (pageNum, pageSize) => axios.get(`${BASE_URL}/api/Reports/Batch?pageNum=${pageNum}&pageSize=${pageSize}`);

const getUnmanagedReports = (model, cancelToken) => axios.post(`${BASE_URL}/api/Reports/Unmanaged`, model, {
    cancelToken,
});

const sendAllTransfers = (type) => axios.post(`${BASE_URL}/api/Reports/SendAllTransfers/${type}`);
const cancelAllTransfers = () => axios.put(`${BASE_URL}/api/Reports/CancelSendingAllTransfers`);

export default {
    search,
    getUnmanagedReports,
    getReportContract,
    getPayments,
    getReport,
    getDriverContract,
    getVehicleContract,
    getVirtualContracts,
    getPrivateVehicleContracts,
    update,
    setPayment,
    getReportImages,
    getReportImagesAdmin,
    approvePayment,
    disapprovePayment,
    setAsPaid,
    completeTransfers,
    exportXsl,
    exportPaidReportsXsl,
    setStatus,
    setStatuses,
    setAsUnpaid,
    setPayments,
    deleteStatus,
    deleteReport,
    setDeliveryMethod,
    createReport,
    fetchReportData,
    loadReportByNumber,
    forMap,
    getYearlyStatistics,
    produceJerusalemSingleReference,
    pullTransfersFromReport,
    updateTransferDocuments,
    adminSearch,
    adminSearchTransfers,
    getReportAdmin,
    getRePortCalls,
    updateAdmin,
    getFields,
    importReports,
    importSingleReport,
    importReportsStatus,
    scanDetailsFromMunic,
    generateAlerts,
    importPolice,
    scanData,
    scanReports,
    updateReportAlert,
    importSmartReports,
    getReportQrDetails,
    exportReportsXslBy,
    exportXslAdmin,
    removeFromProfile,
    getBatchReports,
    exportUnmanagedReportsXsl,
    getTransferAdminById,
    sendAllTransfers,
    cancelAllTransfers,
};
